import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'
import { CommunicationService } from 'src/app/services/Communication/communication.service';
import { Ng2ImgMaxService } from 'ng2-img-max';

@Component({
  selector: 'app-question-answer',
  templateUrl: './question-answer.component.html',
  styleUrls: ['./question-answer.component.css']
})
export class QuestionAnswerComponent implements OnInit {

  ClassList: any;
  Submitted: boolean = false;
  QuestionAnswerList: any;
  
  dropdownSettings: any = {};
  selectedItems: any = [];
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  constructor(private ng2ImgMax: Ng2ImgMaxService,private commservice: CommunicationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
   
    // onImageChange(event) {
    //   let image = event.target.files[0];
     
    //   this.ng2ImgMax.resizeImage(image, 1024, 300).subscribe(
    //     result => {
    //       // this.uploadedImage = result;
    //       this.SelectedFileForUpload=result;
         
    //     },
    //     error => {
    //       console.log('😢 Oh no!', error);
    //     }
    //   );
    // }
    uploadedImage:Blob;
    onImageChange(event) {
      this.spinnerService.show();
      let image = event.target.files[0];     
      this.ng2ImgMax.compressImage(image,2).subscribe(
        result => {
         this.SelectedFileForUpload=result;
        
         this.spinnerService.hide();
        },
        error => {
          this.SelectedFileForUpload=image;
          
          this.spinnerService.hide();
          
        }
      );
    }
    Content:""
    SelectedFileForUpload:any;
   
  SearchModel = {
    QuestionTypeID: 0,
    CurrentIndex: 0,
    FromDate:'',
    ToDate:'',
    PageSize: 0,
  }


  ClearSearch() {
    this.SearchModel.QuestionTypeID = 0;
    this.SearchModel.FromDate='';
    this.SearchModel.ToDate='';
    this.QuestionAnswerList = [];

  }
  // Paging
  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }
  GetAllQuestionAnswer() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.SearchModel.FromDate = this.SearchModel.FromDate != null && this.SearchModel.FromDate != '' ? moment(this.SearchModel.FromDate).format('DD-MMM-YYYY') : '';
    this.SearchModel.ToDate = this.SearchModel.ToDate != null && this.SearchModel.ToDate != '' ? moment(this.SearchModel.ToDate).format('DD-MMM-YYYY') : '';
   
    this.commservice.GetAllQuestionAnswer(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.QuestionAnswerList = response.QuestionAnswerList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.recordCount = 0;
      if (response.QuestionAnswerList != null && response.QuestionAnswerList.length > 0) {
        this.recordCount = response.QuestionAnswerList[0].RecordCount;
      }
      this.numberOfPages();

    });
  };



  QuestionModel = {
    QAID: 0,
    QuestionTypeID: 0,
    Question: '',
    Answer: '',
    QuestionDate: '',
    IsActive: true,
    ClassIDs: '',
    ClassArray: [],
    Heading:""
  };

  Clear() {
    this.QuestionModel.QAID = 0;
    this.QuestionModel.Question = '';
    this.QuestionModel.Heading = '';
    this.QuestionModel.QuestionDate = '';
    this.QuestionModel.Answer = '';
    this.QuestionModel.QuestionTypeID = 0;
    this.QuestionModel.ClassArray = [];
    this.Submitted = false;
    this.FilePath="";
    this.SelectedFileForUpload=null;
    this.Content="";
    this.fileUploader.nativeElement.value = null;
  };
  RemoveQusestionImage(){    
    this.commservice.RemoveQusestionImage(JSON.stringify(this.QuestionModel)).subscribe((data: any) => {
      
      if (data.webResponse.Status) {
        this.FilePath="";
        
      }
     
      this.GetAllQuestionAnswer();
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);

    });
  }

  SaveQuestionAnswer(valid) {
    this.Submitted = true;
    var ClassID = '';
    for (var j = 0; j < this.QuestionModel.ClassArray.length; j++) {
      if (ClassID == '') {
        ClassID = this.QuestionModel.ClassArray[j].ItemId;
      }
      else {
        ClassID = ClassID + "," + this.QuestionModel.ClassArray[j].ItemId;
      }
    }

    this.QuestionModel.ClassIDs = ClassID;
    if (valid) {
      this.spinnerService.show();
      this.QuestionModel.QuestionDate = this.QuestionModel.QuestionDate != null && this.QuestionModel.QuestionDate != '' ? moment(this.QuestionModel.QuestionDate).format('DD-MMM-YYYY') : '';
      this.commservice.SaveQuestionAnswer(JSON.stringify(this.QuestionModel),this.Content,this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.QuestionModel.QAID == 0) {
             this.Clear();
          
        }
      
        if (data.webResponse.Status){       
         if(this.fileUploader!=undefined){
            this.fileUploader.nativeElement.value = null;
            this.FilePath="";
            this.SelectedFileForUpload=null;
          }
         
          
        }
        this.GetAllQuestionAnswer();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  Edit(obj) {

    this.selectedItems = [];

    var ClassIDs = obj.ClassIDs != null ? obj.ClassIDs.split(',') : '';
    for (var i = 0; i < this.ClassList.length; i++) {
      for (var j = 0; j < ClassIDs.length; j++) {
        if (ClassIDs[j] == this.ClassList[i].ItemId) {
          let item = {
            ItemId: this.ClassList[i].ItemId,
            ItemName: this.ClassList[i].ItemName
          }
          this.selectedItems.push(item)
          break;
        }
      }
    }


    this.QuestionModel.ClassArray = this.selectedItems;
    this.QuestionModel.QAID = obj.QAID;
    this.QuestionModel.QuestionTypeID = obj.QuestionTypeID;
    this.QuestionModel.Question = obj.Question;
    this.QuestionModel.Heading = obj.Heading;
    this.Content = obj.Question;
    this.FilePath = obj.FilePath;
    this.QuestionModel.Answer = obj.Answer;
    this.QuestionModel.QuestionDate = moment(obj.QuestionDate).format('DD-MMM-YYYY');
    this.QuestionModel.IsActive = obj.IsActive;

  };

  FilePath:""
  QuestionAnswerMarkActive(obj) {
    this.Clear();
    this.QuestionModel.QAID = obj.QAID;
    this.QuestionModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.commservice.QuestionAnswerMarkActive(this.QuestionModel.QAID,this.QuestionModel.IsActive).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllQuestionAnswer();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.BindClass();
    this.BindQuestionType();
    this.GetAllQuestionAnswer();
  }

  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
      this.ClassList.splice(0, 1)
    });
  };

  QuestionTypeList = [];
  BindQuestionType() {
    this.lookupservice.GetLookupsList('CommQuestionType', '').subscribe((data: any) => {
      this.QuestionTypeList = data.LookupItems;

    });
  };

}




